const HERO_CAROUSEL_HERO_WIDE_PX = 1340;
const HERO_CAROUSEL_BREAKPOINT_OPTIONS = {
    breakpoints: {
        heroWide: HERO_CAROUSEL_HERO_WIDE_PX
    }
};
export { HERO_CAROUSEL_BREAKPOINT_OPTIONS, HERO_CAROUSEL_HERO_WIDE_PX };
